import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { createAutomation, fetchAutomations } from '../api/resources';

export function AutomationsPage() {
  const { data } = useQuery({ queryKey: ['automations'], queryFn: fetchAutomations });
  const queryClient = useQueryClient();

  const [formState, setFormState] = useState({
    name: '',
    triggerType: 'lead.created',
    triggerConfig: '{}',
    actionType: 'email.send',
    actionConfig: '{}',
    isActive: true,
  });

  const createMutation = useMutation({
    mutationFn: createAutomation,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['automations'] });
      setFormState({ name: '', triggerType: 'lead.created', triggerConfig: '{}', actionType: 'email.send', actionConfig: '{}', isActive: true });
    },
  });

  return (
    <div>
      <div className="page-header">
        <div>
          <h1>Automations</h1>
          <p>Trigger outreach, assignments, and ops without writing code.</p>
        </div>
      </div>

      <div className="card">
        <form
          className="form"
          onSubmit={(e) => {
            e.preventDefault();
            try {
              const triggerJson = JSON.parse(formState.triggerConfig || '{}');
              const actionJson = JSON.parse(formState.actionConfig || '{}');
              createMutation.mutate({
                name: formState.name,
                triggerType: formState.triggerType,
                triggerConfig: triggerJson,
                actionType: formState.actionType,
                actionConfig: actionJson,
                isActive: formState.isActive,
              });
            } catch (err) {
              alert('Trigger or action config must be valid JSON');
            }
          }}
        >
          <label>
            Name
            <input value={formState.name} onChange={(e) => setFormState((s) => ({ ...s, name: e.target.value }))} required />
          </label>
          <div className="form-grid">
            <label>
              Trigger type
              <input value={formState.triggerType} onChange={(e) => setFormState((s) => ({ ...s, triggerType: e.target.value }))} />
            </label>
            <label>
              Action type
              <input value={formState.actionType} onChange={(e) => setFormState((s) => ({ ...s, actionType: e.target.value }))} />
            </label>
          </div>
          <label>
            Trigger config (JSON)
            <textarea rows={4} value={formState.triggerConfig} onChange={(e) => setFormState((s) => ({ ...s, triggerConfig: e.target.value }))} />
          </label>
          <label>
            Action config (JSON)
            <textarea rows={4} value={formState.actionConfig} onChange={(e) => setFormState((s) => ({ ...s, actionConfig: e.target.value }))} />
          </label>
          <label className="checkbox">
            <input
              type="checkbox"
              checked={formState.isActive}
              onChange={(e) => setFormState((s) => ({ ...s, isActive: e.target.checked }))}
            />
            Active
          </label>
          <div className="form-actions">
            <button className="btn btn--primary" type="submit" disabled={createMutation.isPending}>
              {createMutation.isPending ? 'Saving…' : 'Create automation'}
            </button>
          </div>
        </form>
      </div>

      <div className="card">
        <table className="table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Trigger</th>
              <th>Action</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((rule) => (
              <tr key={rule.id}>
                <td>{rule.name}</td>
                <td>{rule.trigger_type}</td>
                <td>{rule.action_type}</td>
                <td>{rule.is_active ? 'Active' : 'Paused'}</td>
              </tr>
            ))}
            {!data?.length && (
              <tr>
                <td colSpan={4}>No automations configured.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
